import ApiService from '@/services/ApiService';
import { serialize } from '@/utils/helper';

export default {
  requestFriend(data) {
    return ApiService().post("/friend/request", data, true);
  },
  acceptFriend(id) {
    return ApiService().put('friend/accept/'+id, null, true);
  },
  denyFriend(id) {
    return ApiService().put('friend/deny/'+id, null, true);
  },
  addKeyChat(id) {
    return ApiService().post('/chat/add-key/'+id, null, true);
  },
  deleteKeyChat(id) {
    return ApiService().delete('/chat/delete-key/'+id, null, true);
  },
  getKeyChat(id){
    return ApiService().get('/chat/get-key/'+id);
  },
  getKeyChatRetry(id, failedKeys){
    return ApiService().post('/chat/get-key-retry', {
      "filter_user": id,
      "except_hash": failedKeys.join(','),
      "sort_desc": "createdDate"
    });
  },
  getUserByKeyChat(id){
    return ApiService().get('/chat/get-user-by-key/'+id);
  },
  getFriends(){
    return ApiService().get('/friend/list');
  },
  pushMessage(data) {
    return ApiService().post('/chat/push-message', data, true);
  },
  loadMoreOld(id, page) {
    return ApiService().get(`/chat/get-conversation/${id}/${page}`);
  },
  deleteMessage(data) {
    return ApiService().delete('/chat/delete-message', data, true);
  },
  deleteConversation(id) {
    return ApiService().delete(`/chat/delete-conversation/${id}`, null, true);
  },
  disconnectFriend(id) {
    return ApiService().delete(`/friend/disconnect/${id}`, null, true);
  },
  blockFriend(id) {
    return ApiService().put(`/friend/block/${id}`, null, true);
  },
  unblockFriend(id) {
    return ApiService().put(`/friend/unblock/${id}`, null, true);
  },
}